import React, { useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../../redux/store';
import GRB2CoverPage from './GRB2CoverPage';
import GRB2PrintView from '../PrintView';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';

type OwnProps = {
	showCoverPages?: boolean;
	vesselId: string;
};
type GRB2InspectorViewProps = PropsFromRedux & OwnProps;
function GRB2InspectorView(props: GRB2InspectorViewProps) {
	const { showCoverPages, vesselId } = props;
	const topDivRef = useRef<HTMLDivElement | null>(null);
	useOnScrollToTop(topDivRef);
	return (
		<div>
			<div className="h-0" ref={topDivRef} />
			{showCoverPages ? <GRB2CoverPage vesselId={vesselId} /> : null}
			<div className="newpage">
				<GRB2PrintView />
			</div>
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(GRB2InspectorView);
